import {Base} from "@/api/Base"

export class SubjectList extends Base {
    path = "subject/list"
}